/** Splits a note into its "# " title line and the rest; a note without one has an empty title. */
const splitTitledDocument = (content) => {
  const text = String(content || '');
  const match = text.match(/^# (.*)\n?/);

  if (!match) {
    return { title: '', body: text };
  }

  return { title: match[1].trim(), body: text.slice(match[0].length).replace(/^\n/, '') };
};

export default splitTitledDocument;
